/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetSupportTypeCategoriesResponse } from '../../models/get-support-type-categories-response';

export interface GetSupportTypeCategories$Params {
}

export function getSupportTypeCategories(http: HttpClient, rootUrl: string, params?: GetSupportTypeCategories$Params, context?: HttpContext): Observable<StrictHttpResponse<GetSupportTypeCategoriesResponse>> {
  const rb = new RequestBuilder(rootUrl, getSupportTypeCategories.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetSupportTypeCategoriesResponse>;
    })
  );
}

getSupportTypeCategories.PATH = '/client/getSupportTypeCategories';
